<template>
  <Modal ref="infoModal" title="Informações">
    <Tabs :options="['Dados Básicos', 'Financeiro', 'Histórico']">
      <div slot="Dados Básicos" class="tab-content dados-basicos-container">
        <div v-if="loading" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else>
          <img :src="`data:image/png;base64,${aluno.photoApp}`" alt="" class="perfil">

          <div class="dados-basicos-infos">
            <div class="inputs-row">
              <Input legend="Nome" :modelValue="aluno.nome" readonly />
              <Input legend="Descrição do processo" :modelValue="aluno.descricao_processo || '-'" readonly />
            </div>
            <div class="inputs-row">
              <Input legend="CPF" :modelValue="utils.formatarCPF(aluno.cpf)" readonly />
              <Input legend="Número de processo" :modelValue="aluno.tipo_processo || '-'" readonly />
            </div>
            <div class="inputs-row">
              <Input legend="Renach" :modelValue="aluno.renach" readonly />
              <Input legend="Início do processo" :modelValue="utils.formatOnlyDate(aluno.inicio_processo)" readonly />
            </div>
          </div>
        </template>
      </div>

      <div slot="Financeiro" class="tab-content financeiro-container">
        <div v-if="loading" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else>
          <div class="actions">
            <Button @handle:click="updatePayments" text="Atualizar faturas" color="secondary" :disabled="loadingActions"
              data-testid="btn-atualizar-faturas">
              <Reload :size="18" />
            </Button>
          </div>

          <template v-if="aluno">
            <h3>Status do aluno</h3>

            <Table :headers="['Prático', 'Teórico']">
              <tr>
                <td v-if="aluno.bloqueio_pratico" class="red">
                  <Close :size="19" /> Bloqueado
                </td>
                <td v-else class="green">
                  <Check :size="19" /> Ativo
                </td>
                <td v-if="aluno.bloqueio_teorico" class="red">
                  <Close :size="19" /> Bloqueado
                </td>
                <td v-else class="green">
                  <Check :size="19" /> Ativo
                </td>
              </tr>
            </Table>
          </template>

          <h3>Faturas</h3>

          <Table :headers="['Processo', 'Tipo', 'Status', 'Data Fatura', 'Pagamento', 'Valor']">
            <tr v-if="!faturas.length">
              <td colspan="6">
                <div class="text-center">
                  Não Possui Faturas
                </div>
              </td>
            </tr>
            <tr v-for="fatura in faturas" :key="fatura.id">
              <td>{{ fatura.codigo_processo }}</td>
              <td>{{ fatura.tipo.tipo }}</td>
              <td>{{ fatura.status.status }}</td>
              <td>{{ fatura.created_at ? utils.formatOnlyDate(fatura.created_at.split(' ')[0]) : '-' }}</td>
              <td>{{ fatura.data_pagamento ? fatura.data_pagamento : '-' }}</td>
              <td>{{ utils.formatarValor(fatura.valor) }}</td>
            </tr>
          </Table>
        </template>
      </div>

      <div slot="Histórico" class="tab-content historico-container">
        <div v-if="loading" class="loading">
          <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#1C2D5A'" :size="80" class="mx-2">
          </component>
        </div>

        <template v-else>
          <!-- <div v-if="modal.conteudo.etapa" class="row">
            <div class="col-md-12 text-center">
              <strong class="font-weight-bold">Etapa:</strong><br>
              {{ modal.conteudo.etapa.etapa.titulo }}
            </div>
          </div>
          <br><br>
  
          <div class="col-md-3">
            <button @click="showData()" id="button" class="btn btn-micro btn-secondary"
              style="margin-left: 20px; margin-top: -70px;"><i class="fa fa-search"></i> Dados</button>
          </div> -->

          <div>
            <h3>Resumo das Aulas</h3>

            <CargaHorariaTeoricaTable :cargaHoraria="cargaHoraria" />
          </div>

          <div>
            <h3>Aulas de Reposição</h3>

            <Table :headers="['Matéria', 'Turma', 'Status da Aula', 'Inicio', 'Fim', 'Presença', 'Fotos']">
              <tr v-if="!aulasReposicao.length">
                <td colspan="7" class="text-center">Aluno não possui aulas de reposição</td>
              </tr>
              <tr v-for="turma in aulasReposicao" :key="turma.id_turma_teorica">
                <td>{{ turma.aula.materia.titulo }}</td>
                <td>{{ turma.aula.turma.titulo }}</td>
                <td>{{ statusAluno(turma.aula.id_turma_teorica) }}</td>
                <td>{{ utils.formatDate(turma.aula.inicio) }}</td>
                <td>{{ utils.formatDate(turma.aula.fim) }}</td>
                <td>
                  <span v-if="presencaAluno(turma.aula.id_turma_teorica)">Presença</span>
                  <span
                    v-else-if="diaDaAulaPassou(turma.aula.inicio) && !presencaAluno(turma.aula.id_turma_teorica)">Falta</span>
                  <span v-else-if="diaDaAulaNaoRealizada(turma.aula.inicio)">Não Realizada</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <button v-if="presencaAluno(turma.aula.id_turma_teorica)" title="Visualizar Foto"
                    class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="openModalReposicao(turma)">
                    <span aria-hidden="true" class="fa fa-picture-o" style="font-size: 20px; padding-left: 3px"></span>
                  </button>
                  <p v-else>-</p>
                </td>
              </tr>
            </Table>
          </div>

          <div>
            <h3>Aulas Teóricas</h3>

            <Table :headers="['Matéria', 'Turma', 'Status da Turma', 'Inicio', 'Fim', 'Presença', 'Fotos']">
              <tr v-if="!aulasTeoricas.length">
                <td colspan="7" class="text-center">Aluno não possui aulas teóricas</td>
              </tr>
              <tr v-for="aula in aulasTeoricas" :key="aula.id_aula_teorica">
                <td>{{ aula.materia.titulo }}</td>
                <td>{{ aula.turma.titulo }}</td>
                <td>{{ statusAluno(aula.id_turma_teorica) }}</td>
                <td>{{ utils.formatDate(aula.inicio) }}</td>
                <td>{{ utils.formatDate(aula.fim) }}</td>
                <td>
                  <span v-if="presencaAluno(aula.id_turma_teorica)">Presença</span>
                  <span v-else-if="diaDaAulaPassou(aula.inicio) &&
                    !presencaAluno(aula.id_turma_teorica)">Falta</span>
                  <span v-else-if="diaDaAulaNaoRealizada(aula.inicio)">Não Realizada</span>
                  <span v-else>-</span>
                </td>
                <td>
                  <button v-if="presencaAluno(aula.id_turma_teorica)" title="Visualizar Foto"
                    class="btn btn-primary btn-with-icon rounded-icon btn-micro" @click="openModalTeorica(aula.turma)">
                    <span aria-hidden="true" class="fa fa-picture-o" style="font-size: 20px; padding-left: 3px"></span>
                  </button>
                  <p v-else>-</p>
                </td>
              </tr>
            </Table>
          </div>

          <div>
            <h3>Aulas Práticas</h3>

            <Table :headers="['Turno', 'Veículo', 'Status da aula', 'Data', 'Presença']">
              <tr v-for="aula in aulasPraticas" :key="aula.id_aulas_praticas">
                <td>{{ aula.tipo_aula }}</td>
                <td>{{ aula.veiculo.placa }}</td>
                <td v-if="aula.status != null"> {{ aula.status }} </td>
                <td v-else-if="aula.id_anotacao_pratica == null"> Aula não realizada. </td>
                <td v-else-if="aula.processada == false"> Aguardando processamento. </td>
                <td v-else-if="aula.processada == true"> Aula processada. </td>
                <td v-else> - </td>
                <td>{{ utils.formatDate(aula.data_aula) }}</td>
                <td>
                  <span v-if="aula.id_anotacao_pratica">Presença</span>
                  <span v-else-if="!aula.id_anotacao_pratica && diaDaAulaPassou(aula.data_aula)">Falta</span>
                  <span v-else-if="diaDaAulaNaoRealizada(aula.data_aula)">Não Realizada</span>
                  <span v-else>-</span>
                </td>
              </tr>
            </Table>
          </div>
        </template>
      </div>
    </Tabs>

    <Modal ref="presencareposicao" title="Presença do aluno(a)">
      <div class="presencas-container">
        <table class="presencas-table">
          <thead>
            <tr class="presencas-table-header">
              <th>Útlimas Fotos</th>
              <th>Tipo</th>
              <th>Horário</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(presenca, index) in modalPresencasReposicao" :key="index" class="presencas-table-content">
              <td>
                <img width="100" :src="'data:image/jpg;base64, ' + presenca.foto" alt="Foto">
              </td>
              <td v-show="presenca.tipo == 0">Entrada</td>
              <td v-show="presenca.tipo == 1" class="red">Saída</td>
              <td v-show="presenca.tipo == 2">Intervalo</td>
              <td v-show="presenca.tipo.length > 1">{{ presenca.tipo }}</td>
              <td>{{ utils.formatDate(presenca.created_at) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="presencas-photos-container">
          <h3>Fotos aulas teóricas</h3>

          <div class="photos">
            <span v-if="!modalFotosReposicao.length">Sem fotos teóricas</span>
            <img v-for="(foto, index) in modalFotosReposicao" :key="index" :src="'data:image/jpg;base64, ' + foto.foto"
              alt="Fotos teóricas">
          </div>
        </div>
      </div>
    </Modal>

    <Modal ref="presenca" title="Presença do aluno(a)">
      <div class="presencas-container">
        <table class="presencas-table">
          <thead>
            <tr class="presencas-table-header">
              <th>Útlimas Fotos</th>
              <th>Tipo</th>
              <th>Horário</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(presenca, index) in modalPresencas" :key="index" class="presencas-table-content">
              <td>
                <img width="100" :src="'data:image/jpg;base64, ' + presenca.foto" alt="Foto">
              </td>
              <td v-show="presenca.tipo == 0">Entrada</td>
              <td v-show="presenca.tipo == 1" class="red">Saída</td>
              <td v-show="presenca.tipo == 2">Intervalo</td>
              <td v-show="presenca.tipo.length > 1">{{ presenca.tipo }}</td>
              <td>{{ utils.formatDate(presenca.created_at) }}</td>
            </tr>
          </tbody>
        </table>

        <div class="presencas-photos-container">
          <h3>Fotos aulas teóricas</h3>

          <div class="photos">
            <span v-if="!modalFotos.length">Sem fotos teóricas</span>
            <img v-for="(foto, index) in modalFotos" :key="index" :src="'data:image/jpg;base64, ' + foto.foto"
              alt="Fotos teóricas">
          </div>
        </div>
      </div>
    </Modal>
  </Modal>
</template>

<script>
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import urlApiV2 from '../../router/urlApiV2'
import utils from '../../services/utils'
import Modal from '../core/Modal'
import Tabs from '../core/Tabs'
import Input from '../core/Input'
import Table from '../core/Table'
import Button from '../core/Button'
import CargaHorariaTeoricaTable from '../teoricas/cargaHorariaTeoricaTable'
import Close from 'icons/Close'
import Check from 'icons/Check'
import Reload from 'icons/Reload'

export default {
  name: 'InfoModal',
  components: {
    ...spinners,
    Modal,
    Tabs,
    Input,
    Table,
    Button,
    CargaHorariaTeoricaTable,

    Close,
    Check,
    Reload,
  },
  data() {
    return {
      schema: localStorage.getItem('schema'),
      utils: utils,
      aluno: {},
      faturas: [],
      cargaHoraria: [],
      aulasReposicao: [],
      aulasTeoricas: [],
      aulasPraticas: [],
      presencas: [],
      planos: [],
      modalFotos: [],
      modalFotosReposicao: [],
      modalPresencas: [],
      modalPresencasReposicao: [],
      loading: false,
      loadingCargaHoraria: false,
      loadingActions: false,
    }
  },
  async created() {
    await this.$http.get(`${urlApi}/planos/praticos`)
      .then((response) => {
        this.planos = response.body.dados
      })
  },
  methods: {
    async open(idAluno) {
      await this.detalhes(idAluno)
    },
    async detalhes(idAluno) {
      this.$refs.infoModal.open()

      this.loading = true

      await this.$http.get(`${urlApi}/alunos/${idAluno}`)
        .then(async (response) => {
          this.aluno = response.body.dados
          this.faturas = response.body.dados.faturas
          this.aulasReposicao = response.body.dados.reposicoes

          response.body.dados.turmas.forEach(turma => {
            this.aulasTeoricas.push(...turma.turma.aulas)
          })

          this.aulasPraticas = response.body.dados.aulas
          this.presencas = response.body.dados.presencas

          await this.loadCargaHoraria(this.aluno.id_aluno),

            await this.$http.get(`${urlApi}/aulas/praticas/aluno/${idAluno}`)
              .then((response) => {
                response.body.dados.forEach(pratica => {
                  this.planos.forEach((plano, index) => {
                    if (pratica.anotacao) {
                      if (pratica.anotacao.edu_content == plano.constante) {
                        if (!this.planos[index].numero) {
                          this.planos[index].numero = 1
                        } else {
                          this.planos[index].numero += 1
                        }
                      }
                    }
                  })
                })
              })
              .catch((err) => {
                this.toast(err.body.dados)
              })
        })
        .catch((err) => {
          this.$refs.infoModal.close()

          this.toast('Erro ao buscar detalhes do aluno.')
          this.toast(err.body.dados)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async loadCargaHoraria(aluno) {
      this.loadingCargaHoraria = true

      const params = {
        aluno,
        schema: this.schema,
      }

      await this.$http.get(`${urlApiV2}/aulas/teoricas/alunos/cargahoraria`, {
        params
      })
        .then(response => {
          this.cargaHoraria = response.body.dados
        })
        .catch(err => {
          this.toast('Erro ao buscar carga horária, contate o suporte.')
        })
        .finally(() => {
          this.loading = false
        })
    },
    statusAluno(idTurma) {
      const presencaEncontrada = this.presencas.find(presenca => {
        return idTurma === presenca.id_turma_teorica
      })

      if (presencaEncontrada == undefined) {
        return '-'
      }

      return presencaEncontrada.status
    },
    presencaAluno(idTurma) {
      const presencaEncontrada = this.presencas.find(presenca => {
        return idTurma === presenca.id_turma_teorica
      })

      if (presencaEncontrada == undefined) {
        return false
      }

      return true
    },
    diaDaAulaPassou(aula) {
      if (new Date(aula) < new Date()) {
        return true
      }

      return false
    },
    diaDaAulaNaoRealizada(aula) {
      if (new Date(aula) > new Date()) {
        return true
      }

      return false
    },
    async openModalReposicao(turma_reposicao) {
      await this.$http.get(urlApi + '/alunos/detalhes-presencas/' + turma_reposicao.id_aluno + '/' + turma_reposicao.aula.id_turma_teorica + '/ALUNO/' + turma_reposicao.aula.virtual)
        .then((response) => {
          this.modalFotosReposicao = response.body.dados.fotos_teoricas
          this.modalPresencasReposicao = response.body.dados.presencas
          this.$refs.presencareposicao.open()
        })
    },
    async openModalTeorica(turma) {
      await this.$http.get(urlApi + '/alunos/detalhes-presencas/' + this.aluno.id_aluno + '/' + turma.id_turma_teorica + '/ALUNO/' + turma.virtual)
        .then((response) => {
          console.log(response)
          this.modalFotos = response.body.dados.fotos_teoricas
          this.modalPresencas = response.body.dados.presencas
          this.$refs.presenca.open()
        })
    },
    toast(text) {
      this.$toasted.show(text, {
        icon: 'fa-times',
        position: 'top-right',
        duration: 5000,
        fullWidth: false
      })
    },
    async updatePayments() {
      this.loading = true

      for (const fatura of this.faturas) {
        if (fatura.status.status == 'PAGO') {
          continue
        }

        this.$toasted.show('Atualizando os dados . . .', {
          position: 'top-right'
        })

        await this.$http.post(`${process.env.VUE_APP_URL_API_V2}/faturamento/baixa-individual`, {
          schema: this.schema,
          fatura: fatura.id
        })
          .then(response => {
            if (response.status == 200) {
              this.$toasted.show(response.data.message, {
                position: 'top-right'
              })
            }
          }).catch(error => {
            this.$toasted.show(error.data.message, {
              position: 'top-right'
            })
          })
      }

      await this.detalhes(this.aluno.id_aluno)
    },
  },
}
</script>

<style lang="scss" scoped>
.tab-content {
  width: 75vw;

  .loading {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  h3 {
    text-align: center;
    margin: 0;
    font-family: Nunito Sans;
    font-size: 1.25rem;
    font-weight: 700;
    color: #000000;
  }
}

.dados-basicos-container {
  display: flex;
  flex-wrap: wrap;
  gap: 3rem;

  .perfil {
    width: 13.25rem;
    border-radius: 10px;
    /* height: 18.5rem; */
    object-fit: contain;
  }

  .dados-basicos-infos {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs-row {
      display: flex;
      align-items: center;
      gap: 1.5rem;

      >div {
        flex: 1;
      }
    }
  }
}

.financeiro-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  .green {
    color: #007B19;
  }

  .red {
    color: #CF0206;
  }

  .actions {
    display: flex;
    align-items: center;

    div {
      padding: 0 0.5rem;
      display: flex;
      justify-content: center;

      &:not(:first-child) {
        border-left: 1px solid #ECECEC;
      }

      &:not(:last-child) {
        border-right: 1px solid #ECECEC;
      }
    }
  }
}

.historico-container {
  display: flex;
  flex-direction: column;
  gap: 3.5rem;

  >div {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }
}

.presencas-container {
  width: 50vw;
  display: flex;
  flex-direction: column;
  gap: 2.0625rem;

  .presencas-table {
    tr {
      border: none;
    }

    .presencas-table-header {
      >th {
        padding: 0.5rem 0.5rem 2rem;
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        color: #1C2D5A;
      }
    }

    .presencas-table-content {
      >td {
        font-size: 1rem;
        font-weight: 700;
        text-align: center;
        color: #1C2D5A;

        &.red {
          color: #E91D23;
        }
      }

      img {
        width: 10.5rem;
        height: 10.5625rem;
        border-radius: 5.74px;
        border: 0.57px solid #A8A8A8;
        object-fit: contain;
      }
    }
  }

  .presencas-photos-container {
    display: flex;
    flex-direction: column;
    gap: 2.0625rem;

    h3 {
      margin: 0;
      display: flex;
      flex-direction: column;
      font-size: 1.5rem;
      font-weight: 700;
      text-align: left;
      color: #202224;
    }

    .photos {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      gap: 2.0625rem;

      >img {
        width: 5.375rem;
        height: 5.375rem;
        border-radius: 2.93px;
        border: 0.29px solid #A8A8A8;
      }
    }
  }
}
</style>